import { AlertService } from './../alert.service';
import { AppComponent } from "../app.component";
import { UserServiceService } from "../user-service.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { User } from "../models/user.model";
import { Router } from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  private user: User = {};

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserServiceService,
    private router: Router,
    private alertService : AlertService
  ) {
    this.loginForm = this.formBuilder.group({
      email: ["", Validators.required],
      password: ["", Validators.required]
    });
  }

  ngOnInit() {}

  login() {
    console.log("clicked....");

    

    this.user.username = this.loginForm.value.email;
    this.user.password = this.loginForm.value.password;
    AppComponent.user = this.user;
    console.log(AppComponent.user);
    this.userService.login(this.user).subscribe(data => {
      console.log(data);
      if (data == 403) { this.alertService.showAlert("Wrong Username and/or password",4);
      } else {
        //AppComponent.user = data;
        AppComponent.loggedInUser = data;
        //this.getAllUsers()
        this.router.navigate(["dashboard"]);
        
      }
    });
  }

  getAllUsers(){
    this.userService.get('sagpan/admin_user_data.php').subscribe(data =>{
      console.log(data);
      AppComponent.USERS = data.data;
      this.router.navigate(["dashboard"]);
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts